import { ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // Extend font-size to include custom display and caps classes
      'font-size': [
        'display-sm',
        'display-base',
        'display-lg',
        'display-xl',
        'display-2xl',
        'caps-label-sm',
        'caps-label-xs',
        'text-xxs',
        'text-xs',
        'text-sm',
        'text-base',
        'text-lg',
        'text-xl',
      ],
      // Extend bg-color to include custom background colors
      'bg-color': [
        'bg-primary',
        'bg-primary-hover',
        'bg-secondary',
        'bg-secondary-hover',
        'bg-tertiary',
        'bg-quaternary',
        'bg-brand-primary',
        'bg-brand-primary-hover',
        'bg-brand-secondary',
        'bg-brand-tertiary',
        'bg-purple',
        'bg-success-primary',
        'bg-success-secondary',
        'bg-success-strong',
        'bg-error-primary',
        'bg-error-secondary',
        'bg-error-strong',
        'bg-warning-primary',
        'bg-warning-secondary',
        'bg-warning-strong',
      ],
      // Extend border-color to include custom border colors
      'border-color': [
        'border-primary',
        'border-secondary',
        'border-tertiary',
        'border-error',
        'border-error-strong',
        'border-brand',
        'border-brand-strong',
        'border-brand-subtle',
        'border-strong',
        'border-warning',
        'border-success',
        'border-purple',
        'border-status-green',
        'border-status-orange',
        'border-status-yellow',
        'border-status-red',
      ],
      // Extend text-color to include custom text colors
      'text-color': [
        'text-primary',
        'text-secondary',
        'text-tertiary',
        'text-quaternary',
        'text-disabled',
        'text-error',
        'text-warning',
        'text-success',
        'text-placeholder',
        'text-purple',
        'text-brand-primary',
        'text-brand-secondary',
        'text-brand-tertiary',
        'text-brand-disabled',
        'text-status-green',
        'text-status-orange',
        'text-status-yellow',
        'text-status-red',
        'text-button-primary',
      ],
    },
  },
});

export const cn = (...inputs: ClassValue[]) => {
  return customTwMerge(clsx(inputs));
};
